import * as axios from "axios";
import { getAuthHeader, getUploadFileHeader, removeAllCookies, setStorage } from "../utils";
import CONSTANT from "./../constant";

export const addUser = (model: any) => {
  const url = `${process.env.REACT_APP_BASE_URL}user/add`;
  return axios.post(url, model, getAuthHeader()).then(
    (response: any) => {
      return response.data;
    },
    (error: any) => {
      alert(error.Message);
    }
  );
};

export const addUserBulk = (file: any) => {
  const url = `${process.env.REACT_APP_BASE_URL}user/add-bulk`;
  return axios.post(url, file, getAuthHeader()).then(
    (response: any) => {
      return response.data;
    },
    (error: any) => {
      alert(error.Message);
    }
  );
};

export const updateUser = (model: any) => {
  const url = `${process.env.REACT_APP_BASE_URL}user/update`;
  return axios.put(url, model, getAuthHeader()).then(
    (response: any) => {
      return response.data;
    },
    (error: any) => {
      alert(error.Message);
    }
  );
};

export const updateContactList = (model: any) => {
  const url = `${process.env.REACT_APP_BASE_URL}user/contact-list`;
  return axios.put(url, model, getAuthHeader()).then(
    (response: any) => {
      if (response.data.error === null) {
        setStorage(CONSTANT.cookie.recipients, response.data.result.recipients);
      }

      return response.data;
    },
    (error: any) => {
      alert(error.Message);
    }
  );
};

export const updateHrDealingOfficer = () => {
  const url = `${process.env.REACT_APP_BASE_URL}hr/dealing/officer`;
  return axios.get(url).then(
    (response: any) => {
      if (response.data.error === null) {
        setStorage(
          CONSTANT.cookie.hrDealingOfficerList,
          response.data.result.hrDealingOfficer
        );
        setStorage(
          CONSTANT.cookie.hrexecutive,
          response.data.result.hrExecutive
        );
        setStorage(CONSTANT.cookie.finance, response.data.result.finance);
      }
      return response.data;
    },
    (error: any) => {
      alert(error.Message);
    }
  );
};

export const updateMedicalReport = (model: any) => {
  const url = `${process.env.REACT_APP_BASE_URL}update/medical`;
  return axios.post(url, model, getAuthHeader()).then(
    (response: any) => {
      return response.data;
    },
    (error: any) => {
      alert(error.Message);
    }
  );
};

export const getUserList = (page: number, limit: number) => {
  const url = `${process.env.REACT_APP_BASE_URL}user/list?p=${page}&l=${limit}`;
  return axios.get(url, getAuthHeader()).then(
    (response: any) => {
      return response.data;
    },
    (error: any) => {
      alert(error.response.data.error);
      removeAllCookies();
      localStorage.removeItem("timer");
      window.location.pathname = "/";
    }
  );
};

export const getApprovingAuthority = () => {
  const url = `${process.env.REACT_APP_BASE_URL}user/approving-authority`;
  return axios.get(url, getAuthHeader()).then(
    (response: any) => {
      return response.data;
    },
    (error: any) => {
      alert(error.response.data.error);
    }
  );
};

export const getParkedFile = () => {
  const url = `${process.env.REACT_APP_BASE_URL}parked-file-details/by-name`;
  return axios.get(url, getAuthHeader()).then(
    (response: any) => {
      return response.data;
    },
    (error: any) => {
      alert(error.response.data.error);
    }
  );
};

export const getUserSummaryList = () => {
  const url = `${process.env.REACT_APP_BASE_URL}user/summary-list`;
  return axios.get(url, getAuthHeader()).then(
    (response: any) => {
      return response.data;
    },
    (error: any) => {
      alert(error.response.data.error);
    }
  );
};

export const getCircualrAccessList = () => {
  const url = `${process.env.REACT_APP_BASE_URL}circular-access-list`;
  return axios.get(url, getAuthHeader()).then(
    (response: any) => {
      return response.data;
    },
    (error: any) => {
      alert(error.response.data.error);
    }
  );
};

export const updateAccessList = (model: any) => {
  const url = `${process.env.REACT_APP_BASE_URL}update-circular-list-access`;
  return axios.post(url, model, getAuthHeader()).then(
    (response: any) => {
      return response.data;
    },
    (error: any) => {
      alert(error.response.data.error);
    }
  );
};

export const getUserDetail = (code: string) => {
  const url = `${process.env.REACT_APP_BASE_URL}user/detail/${code}`;
  return axios.get(url, getAuthHeader()).then(
    (response: any) => {
      return response.data;
    },
    (error: any) => {
      alert(error.response.data.error);
    }
  );
};

export const getBirthDayList = async () => {
  const url = `${process.env.REACT_APP_BASE_URL}user/birthday/list`;
  return axios.get(url, getAuthHeader()).then(
    (response: any) => {
      return response.data;
    },
    (error: any) => {
      alert(error.response.data.error);
    }
  );
};

export const getDashboardData = async (
  range: string,
  userId: string
) => {
  const url = `${process.env.REACT_APP_BASE_URL}file/dashboard?range=${range}&userId=${userId}`;
  return axios.get(url, getAuthHeader()).then(
    (response: any) => {
      return response.data;
    },
    (error: any) => {
      alert(error.response?.data?.error || "Something went wrong");
    }
  );
};


export const getUserSummary = () => {
  const url = `${process.env.REACT_APP_BASE_URL}user/summary`;
  return axios.get(url, getAuthHeader()).then(
    (response: any) => {
      return response.data;
    },
    (error: any) => {
      alert(error.response.data.error);
    }
  );
};

export const getUnitUserSummary = () => {
  const url = `${process.env.REACT_APP_BASE_URL}user/unit-summary-list`;
  return axios.get(url, getAuthHeader()).then(
    (response: any) => {
      return response.data;
    },
    (error: any) => {
      alert(error.response.data.error);
    }
  );
};

export const getProfileDetail = () => {
  const url = `${process.env.REACT_APP_BASE_URL}user/profile`;
  return axios.get(url, getAuthHeader()).then(
    (response: any) => {
      return response.data;
    },
    (error: any) => {
      alert(error.response.data.error);
      removeAllCookies();
      localStorage.removeItem("timer");
      window.location.pathname = "/";
    }
  );
};

export const searchUsers = (keyword: string, page: number, limit: number) => {
  const url = `${
    process.env.REACT_APP_BASE_URL
  }user/search?k=${encodeURIComponent(keyword)}&p=${page}&l=${limit}`;
  return axios.get(url, getAuthHeader()).then(
    (response: any) => {
      return response.data;
    },
    (error: any) => {
      alert(error.response.data.error);
    }
  );
};

export const getClassTypes = () => {
  const url = `${process.env.REACT_APP_BASE_URL}etoor/classType/`;
  return axios.get(url, getAuthHeader()).then(
    (response: any) => {
      return response.data;
    },
    (error: any) => {
      alert(error.response.data.error);
    }
  );
};

export const getClassTypeCities = (className: any) => {
  const url = `${process.env.REACT_APP_BASE_URL}etoor/classType/cities`;
  return axios.post(url, { className: className }, getAuthHeader()).then(
    (response: any) => {
      return response.data;
    },
    (error: any) => {
      alert(error.response.data.error);
    }
  );
};

export const getDailyAllowanceList = () => {
  const url = `${process.env.REACT_APP_BASE_URL}etoor/DA/list`;
  return axios.get(url, getAuthHeader()).then(
    (response: any) => {
      return response.data;
    },
    (error: any) => {
      alert(error.response.data.error);
    }
  );
};

export const getCityAndClassId = (
  className: any,
  cityName: any,
  daName: any
) => {
  const url = `${process.env.REACT_APP_BASE_URL}etoor/city/class/id`;
  const model = { className: className, cityName: cityName, daName: daName };

  return axios.post(url, model, getAuthHeader()).then(
    (response: any) => {
      return response.data;
    },
    (error: any) => {
      alert(error.response.data.error);
    }
  );
};

export const getDAValue = (model: any) => {
  const url = `${process.env.REACT_APP_BASE_URL}etoor/get/DA/value`;
  return axios.post(url, model, getAuthHeader()).then(
    (response: any) => {
      return response.data;
    },
    (error: any) => {
      alert(error.response.data.error);
    }
  );
};

export const uploadProfilePicture = (file: File) => {
  const url = `${process.env.REACT_APP_BASE_URL}user/profile-picture`;
  const formData = new FormData();
  formData.append("profilePicture", file);
  return axios.post(url, formData, getUploadFileHeader()).then(
    (response: any) => {
      return response.data;
    },
    (error: any) => {
      alert(error.response?.data?.error || "Failed to upload profile picture");
    }
  );
};

export const uploadProfilePictureByAdmin = (userCode: string, file: File) => {
  const url = `${process.env.REACT_APP_BASE_URL}user/profile-picture/${userCode}`;
  const formData = new FormData();
  formData.append("profilePicture", file);
  return axios.post(url, formData, getUploadFileHeader()).then(
    (response: any) => {
      return response.data;
    },
    (error: any) => {
      alert(error.response?.data?.error || "Failed to upload profile picture");
    }
  );
};
